// extracted by mini-css-extract-plugin
export default {"productGrid":"F2-z","centerLink":"G2-z","productSection":"H2-z","item":"I2-z","ctaButton":"J2-z"};